class ScxProductImageSwiper extends HTMLElement {
  constructor() {
    super();

    this.swiperId = this.id;
    this.dataSelector = this.getAttribute('data-selector');
    this.dataTargetSelector = this.getAttribute('data-target-selector');
    const loadingElem = this.getAttribute('data-loading-elem');
    this.loadingDiv = document.querySelector(`.${loadingElem}`);
    this.swiperDiv = document.querySelector(`.${this.dataSelector}`);
    this.ignoreLazyLoading = this.shouldIgnoreLazyLoad();

    // Swiper configuration
    this.swiperInstance;
  }

  shouldIgnoreLazyLoad() {
    let dLazy = this.getAttribute('data-lazy');
    if (dLazy === null || dLazy === undefined || dLazy === '') {
      return true;
    } else {
      return !dLazy;
    }
  }

  connectedCallback() {
    if (this.ignoreLazyLoading) {
      if (document.readyState === 'complete') {
        // If already loaded, initialize immediately
        this.swiperInstance = new Swiper(`.${this.dataSelector}`, this.getSwiperOptions());
      } else {
        // Otherwise, wait for the load event
        window.addEventListener('load', () => {
          this.swiperInstance = new Swiper(`.${this.dataSelector}`, this.getSwiperOptions());
        });
      }
    } else {
      this.initSwiper();
    }
  }

  initSwiper() {
    // let swiperInstance;

    const initSwiperInstance = (selector) => {
      const s = document.querySelector(selector);

      if (!s) return; // Exit if the selector doesn't exist

      // Cleanup existing Swiper instance
      if (this.swiperInstance) {
        this.swiperInstance.destroy(true, true);
      }

      // Initialize new Swiper instance
      this.swiperInstance = new Swiper(selector, this.getSwiperOptions());
    };

    const moveToFirstSlide = () => {
      if (this.swiperInstance) {
        this.swiperInstance.slideTo(0);
      }
    };

    const moveToSecondSlide = () => {
      if (this.swiperInstance) {
        this.swiperInstance.slideTo(1);
      }
    };


    // Function to create an intersection observer
    const createObserverInstance = (targetSelector, selector) => {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // If the swiper container is in the viewport, initialize it
            console.debug('Creating instance for swiper images...');
            initSwiperInstance(`.${selector}`);
            let firstView = document.querySelector(`.first-view`);
            if (firstView) {
              firstView.addEventListener('click', moveToFirstSlide);
            }
            let secondView = document.querySelector(`.second-view`);
            if (secondView) {
              secondView.addEventListener('click', moveToSecondSlide);
            }
            // Stop observing once initialized
            observer.unobserve(entry.target);
          }
        });
      });

      // Start observing the specified element
      const targetElement = document.querySelector([`.${targetSelector}`]);
      if (targetElement) {
        observer.observe(targetElement);
      }
    };

    // Ensure Swiper initializes on page load
    if (document.readyState === 'complete') {
      // If already loaded, initialize immediately
      createObserverInstance(this.dataTargetSelector, this.dataSelector);
    } else {
      // Otherwise, wait for the load event
      window.addEventListener('load', () => {
        createObserverInstance(this.dataTargetSelector, this.dataSelector);
      });
    }

    // Reinitialize Swiper when a section is loaded or changed in the theme editor
    document.addEventListener('shopify:section:load', (event) => {
      if (event.detail.sectionId === this.id) {
        createObserverInstance(this.dataTargetSelector, this.selector);
      }
    });

    // Cleanup Swiper instance when the section is unloaded
    document.addEventListener('shopify:section:unload', (event) => {
      if (event.detail.sectionId === this.id) {
        if (this.swiperInstance) {
          this.swiperInstance.destroy(true, true);
          this.swiperInstance = null;
        }
      }
    });
  }

  getSwiperOptions = () => {
    return {
      slidesPerView: 1,
      spaceBetween: 0,
      nested: true,
      navigation: {
        nextEl: ".scx-swiper-button-next",
        prevEl: ".scx-swiper-button-prev",
      },
      // ...this.get PaginationOptions(),
      on: {
        init: () => {
          this.loadingDiv.setAttribute('data-loaded', 'true');
          this.swiperDiv.setAttribute('data-loading', 'false');
        },
      },
    };
  };

  getMousewheelOptions = () => {
    const mwElem = this.getAttribute('data-mousewheel');

    if (mwElem === 'true') {
      return {
        mousewheel: {
          forceToAxis: true,
        },
      };
    }

    return {};
  };

  getPaginationOptions = () => {
    const mwElem = this.getAttribute('data-pagination-elem');

    if (mwElem) {
      return {
        pagination: {
          el: mwElem,
          clickable: true,
          dynamicBullets: this.getAttribute('data-dynamic-bullets') == 'true' ? true : false,
        },
      };
    }

    return {};
  };
}

customElements.define('scx-product-image-swiper', ScxProductImageSwiper);
